import React, { useContext, useState } from "react";
import stylesCss from "../../Approval/style";
import { Button, Grid, LinearProgress, TextField } from "@mui/material";
import { ContactContext } from "../../../../../context/contact/ContactContext";
import { useTranslation } from "react-i18next";
import { Tittle } from "../style";

const StepOne = ({ setActiveStep }) => {
  const { t } = useTranslation();
  const classesSx = stylesCss;
  const { rucVendor, setRucVendor, getVendor } = useContext(ContactContext);
  const [wait, setWait] = useState(false);

  const handleNext = () => {
    setActiveStep((prevActiveStep) => prevActiveStep + 1);
  };
  const handleBack = () => {
    setActiveStep((prevActiveStep) => prevActiveStep - 1);
  };
  const submitForm = async (e) => {
    setWait(true);
    e.preventDefault();

    if (rucVendor !== "") {
      const data = await Promise.all([getVendor(rucVendor)]);
      handleNext();
    }
    setWait(false);
  };
  return (
    <>
      {wait && <LinearProgress color="error" />}

      <form
        onSubmit={(e) => {
          submitForm(e);
        }}
      >
        <div>
          <br />
          <Tittle>{t("searchCompany")}</Tittle>
          <br />
          <TextField
            required
            fullWidth
            id="standard-basic"
            label={t("identification")}
            onChange={(e) => setRucVendor(e.target.value)}
          />
        </div>
        <br />
        <br />
        <div>
          <Button
            sx={{ ...classesSx.btnBuscarRegresar }}
            type="submit"
            variant="contained"
            disabled={wait}
          >
            {t("next")}
          </Button>
        </div>
        {/* <Grid container spacing={2} padding={2}>
          <Grid item xs={12} md={12} lg={12}>
            <Grid container spacing={5}>
              <Grid
                item
                xs={6}
                md={6}
                lg={6}
                sx={{
                  ...classesSx.gridBtnRegresar,
                }}
              >
                <Button
                  sx={{ ...classesSx.btnBuscarRegresar }}
                  variant="contained"
                  onClick={handleBack}
                >
                  {t("back")}
                </Button>
              </Grid>
              <Grid
                item
                xs={6}
                md={6}
                lg={6}
                sx={{
                  ...classesSx.gridBtnContinuar,
                }}
              >
                <Button
                  sx={{ ...classesSx.btnBuscarRegresar }}
                  type="submit"
                  variant="contained"
                  //   onClick={onSubmit}
                >
                  {t("next")}
                </Button>
              </Grid>
            </Grid>
          </Grid>
        </Grid> */}
      </form>
    </>
  );
};

export default StepOne;
